<template>
  <el-dialog :visible="visible" :show-close="false" class="firstGuide">
    <div class="firstGuideMain">
      <p>Hi，欢迎来到DOT轻任务平台</p>
      <div class="info">我们为您准备了详细的新手引导教程，一起来学习吧~</div>
      <div class="m-t-25">
        <el-button type="primary" size="medium" round plain @click="closeGuide">
          不用了，谢谢
        </el-button>
        <el-button type="primary" size="medium" round @click="toGuide">
          去看看
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['visible'],
  methods: {
    closeGuide() {
      this.$emit('close-notice');
    },
    toGuide() {
      this.$emit('to-guide');
    },
  },
};
</script>
